import { FC } from 'react';
import { Image, ThemeImageProps } from '@base/lib/ThemeImage';
import site from 'pro/config/site';

export type ILogoProps = Omit<ThemeImageProps, 'src' | 'href' | 'width' | 'height'> & {
    type?: string;    //logo类型
    typeMap: Record<string, string>;  //type 与 src映射
    size?: number;    //渲染宽度
    width: number;   //实际宽度，用于计算图片比例
    height: number;  //实际高度，用于计算图片比例
    href?: boolean | string;
    className?: string;
}

export const Logo: FC<ILogoProps> = (props) => {
    const {
        typeMap,
        width: originWidth,
        height: originHeight,
        type = 'default',
        href,
        size,
        fixed = true,
        className,
        ...rest
    } = props

    const width = size || originWidth;
    const height = width === originWidth ? originHeight : ((width * originHeight) / originWidth)

    return (
        <Image
            className={className}
            href={href === false ? void 0 : (href === true ? '/' : href)}
            src={typeMap[type] || typeMap.default}
            width={width}
            height={height}
            alt={site.brand}
            background={false}
            fixed={fixed}
            {...rest}
        />
    )
};
